const flags = require.context('./', false, /\.png$/);
flags.keys().forEach(flags);
